import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Stack, Typography, useTheme } from '@mui/material';

type PropTypes = {
  closeDailyEtiquette: () => void;
  openDailyEtiquette: boolean;
};

export const DailyEtiquette = ({
  closeDailyEtiquette,
  openDailyEtiquette,
}: PropTypes) => {
  const theme = useTheme();

  return (
    <Dialog
      open={openDailyEtiquette}
      onClose={closeDailyEtiquette}
      maxWidth="sm"
      sx={{
        // '& .MuiPaper-root': {
        //   backgroundImage:
        //     'url(https://res.cloudinary.com/dqlqwdqs9/image/upload/v1676182097/brick_wall_bg_lhwatk.jpg)',
        // },
        '& .paper': {
          borderStyle: 'solid',
          borderColor: theme.palette.ranked.main,
        },
      }}
    >
      <DialogTitle>
        <Typography
          variant="h4"
          textAlign={'center'}
          sx={{
            textShadow:
              theme.palette.mode === 'dark'
                ? `0 0 0px ${theme.palette.dailies.main}, 0 0 0px ${theme.palette.dailies.main}, 0px 0px 16px ${theme.palette.dailies.main}`
                : 'none',
          }}
        >
          What are Dailies?
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ width: '100%', height: '100%' }}>
        <Stack spacing={2}>
          <Typography>
            A single set of 10 questions, just like a "Solo" game.
          </Typography>
          <Typography>
            A new daily will be available every midnight (PST).
          </Typography>
          <Typography>
            Everyone sees the same set of questions for each Daily.
          </Typography>
          <Typography>
            Given the above, it is obvious you can get the answers from someone
            else and cheat. Don't, that's lame.
          </Typography>
          <Typography>
            Dailies questions are brand new and are generated from its own pool.
          </Typography>
          <Typography>
            Dailies do not count towards standard achievements and stats like
            POB% and Aves counts.
          </Typography>
          <Typography>
            Everyone's answer letters reveal in the same sequence.
          </Typography>
          <Typography>
            Dailies are a fun way to play with the community but at your own
            pace. Enjoy!
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={closeDailyEtiquette} fullWidth>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};
